import axios from "./axios_interceptor";
import { get_jwt_token, loginRedirect } from "./helper_funtions";
import FileSaver from "file-saver";

export const myAppsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/apps/apps/?page=${data.page}&limit=${data.limit}&search=${data.search}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const deleteMyApp = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const url = `/apps/app/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const getMyAppDetail = async ({ app_id }) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/app/?app_id=${app_id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const updateMyApp = async ({ app_id, updatedApp }) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/app/?app_id=${app_id}`;
    const response = await axios.put(url, updatedApp, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const addApp = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/app/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const nonAllocatedAppGroupList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/apps/allocate-group/?app_id=${data.app_id}&page=${data.page}&limit=${data.limit}&search=${encodeURIComponent(data.search)}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const allocatedAppGroupList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/apps/deallocate-group/?app_id=${data.app_id}&page=${data.page}&limit=${
      data.limit
    }&search=${encodeURIComponent(data.search)}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const allocateAppToGroupApi = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/allocate-group/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const deallocateAppFromGroup = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/deallocate-group/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const myAppsListUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/apps/userapp/?resourcetype=apps&userid=${data.userid}&page=${data.page}&limit=${data.limit}&search=${data.search}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const myAppsAllocatedSystemUsers = async (app_id) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/apps/userapp/?resourcetype=systemuser&app_id=${app_id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getToken = async () => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/autheticate/resource_authenticate/`;
    const response = await axios.get(url, config);
    return { tokenData: response.data, tokenError: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const storeResourceCredentials = async (username, password, type = null) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/autheticate/resource_authenticate/`;
    const response = await axios.post(
      url,
      {
        username: username.trim(),
        password: password.trim(),
        type: type,
      },
      config,
    );
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors };
  }
};
export const notAllocatedToAppUsersList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/not-allocated-users/?app_id=${data.app_id}&page=${
      data.page
    }&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const allocateUsersToApp = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = {
      user_ids: data.ids,
      app_id: data.app_id,
      allocation_from: data.allocation_from,
      allocation_till: data.allocation_till,
      policy: data.policy,
      systemuser: data.systemuser,
      allocation_type: data.allocation_type,
      start_time: data.start_time,
      end_time: data.end_time,
      allowed_days: data.allowed_days,
      timezone: data.timezone,
    };
    const url = `/apps/allocate-user/?app_id=${data.app_id}&page=${
      data.page
    }&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }`;
    const response = await axios.post(url, body, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const AllocatedUsersToAppList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/allocated-users/?app_id=${data.app_id}&page=${
      data.page
    }&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const DeAllocateUsers = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        user_ids: data.ids,
        app_id: data.app_id,
      },
    };
    const url = `/apps/allocated-users/?app_id=${data.app_id}&page=${data.page}&page_size=${data.page_size}&search=${data.search}&filter_by=${data.filter_by}`;
    const response = await axios.delete(url, config, data);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const ExtendAppAllocation = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/allocate-user/`;
    const response = await axios.put(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getAppAllocationInfo = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        entity_id: data.entity_id,
        app_id: data.app_id,
        entity_type: data.entity_type,
      },
    };
    const response = await axios.get("/apps/app-allocation-window/", config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const TestAppConnection = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/apps/test-connection/?app_id=${data.app_id}&systemuser_id=${data.systemuser_id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};


export const notAllocatedToResourceRolesList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/roles/resource-role-allocate/?resource_id=${
      data.resource_id
    }&resource_type=${data.resource_type}&allocated=${data.allocated}&page=${
      data.page
    }&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const allocateRolesToResource = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = {
      role_ids: data.ids,
      resource_id: data.resource_id,
      resource_type: data.resource_type,
      allocate: data.allocate,
      allocation_from: data.allocation_from,
      allocation_till: data.allocation_till,
      systemuser: data.systemuser,
      policy: data.policy,
      allocation_type: data.allocation_type,
      advance_option: data.advance_option,
      start_time: data.start_time,
      end_time: data.end_time,
      allowed_days: data.allowed_days,
      timezone: data.timezone,
    };
    const url = `/roles/resource-role-allocate/`;
    const response = await axios.post(url, body, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const ExtendRoleAllocation = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/roles/resource-role-allocate/`;
    const response = await axios.put(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getAccessedAppPolicy = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/apps/app-accessed-policy/?app_id=${data.app_id}&system_user=${data.system_user}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
